import { createTheme } from "@mui/material/styles";
import { tokens } from "./tokens";

const Typography = () => {
  return createTheme({
    typography: {
      fontFamily: "'Inter', sans-serif",
      htmlFontSize: 16,
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightMedium: 500,
      fontWeightBold: 600,
      // The page title (PageHeader).
      h1: {
        fontWeight: 700,
        fontSize: "1.5rem",
        lineHeight: 1.2,
        letterSpacing: "-0.02em",
        color: tokens.ink,
        "@media (min-width:900px)": {
          fontSize: "28px",
        },
      },
      h2: {
        fontWeight: 600,
        fontSize: "1.75rem",
        lineHeight: 1.3,
        color: tokens.ink,
        letterSpacing: "-0.01em",
      },
      h3: {
        fontWeight: 600,
        fontSize: "1.25rem",
        lineHeight: 1.33,
        color: tokens.ink,
      },
      h4: {},
      h5: {
        color: tokens.accent,
        fontWeight: 500,
        fontSize: "12px",
      },
      h6: {
        color: tokens.ink,
        fontSize: "18px",
        fontWeight: "600",
      },
      body1: {
        fontSize: "14px",
        fontWeight: 400,
        color: tokens.ink,
      },
      body2: {
        color: tokens.ink,
        fontSize: "13px",
        fontWeight: 500,
      },
      subtitle1: {
        color: tokens.muted,
        fontSize: "11px",
      },
      subtitle2: {
        color: tokens.muted,
        fontSize: "13px",
        fontWeight: 400,
      },
    },
  });
};

export default Typography;
